<template>
  <div class="room socket-record">
    Socket记录
  </div>
</template>
<script>
export default {
  name: 'socketRecord',
  data () {
    return {}
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.socket-record {
}
</style>
